import React from 'react';
const HostContext = React.createContext(undefined);
export const HostProvider = React.memo(({ children, host }) => {
    return React.createElement(HostContext.Provider, { value: host }, children);
});
export function useHost() {
    const context = React.useContext(HostContext);
    if (context === undefined) {
        throw new Error('useHost must be used within a HostProvider');
    }
    return context;
}
//# sourceMappingURL=host-context.js.map